// extracted by mini-css-extract-plugin
module.exports = {"InternalTransferCardPreview":"InternalTransfer_InternalTransferCardPreview__17d12"};